var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my_edit_btn lineControl",class:_vm.tabName==='style'?'styleContent':'animateContent',attrs:{"title":_vm.title?_vm.title:_vm.baseTitle},on:{"click":_vm.changeStyle}},[_c('span',{class:_vm.tabName === 'style' ? 'el-icon-edit' : 'el-icon-magic-stick'})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25bdfb6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my_edit_btn/index.vue
// module id = null
// module chunks = 